import React from 'react';
import { toMs } from '../../utils/askThread';

function clock(ts) {
  const ms = toMs(ts);
  if (!ms) return '';
  try { return new Date(ms).toLocaleTimeString(); } catch { return ''; }
}

// "Investigating, N steps": one line per trail entry (tool name, one-line result, time).
// Open while the turn is working, collapsed once it finishes.
export default function TrailList({ trail, working }) {
  const list = Array.isArray(trail) ? trail.filter((e) => e && typeof e.tool === 'string') : [];
  if (!list.length && !working) return null;
  return (
    <details className="ask-trail" open={!!working}>
      <summary>{`Investigating, ${list.length} ${list.length === 1 ? 'step' : 'steps'}`}</summary>
      <ul className="ask-trail-list" aria-live={working ? 'polite' : undefined}>
        {list.map((e, i) => {
          const t = clock(e.ts);
          return (
            <li key={i} className="ask-trail-item">
              <code className="ask-mono">{e.tool}</code>
              <span>{e.summary}</span>
              {t ? <time className="ask-muted-note">{t}</time> : null}
            </li>
          );
        })}
      </ul>
    </details>
  );
}
